import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { fbIcon, igIcon, drIcon, beIcon, inIcon } from "../assets/svg";
import InlineSVG from "svg-inline-react";
import onClickOutside from "react-onclickoutside";

let icons = [fbIcon, igIcon, drIcon, beIcon, inIcon];
let socialMedia = [
  {
    link: "https://www.facebook.com/uon.rs/",
    icon: fbIcon
  },
  {
    link: "https://www.instagram.com/uon.rs/",
    icon: igIcon
  },
  /* currently uon doesn't have behance and dribble
  {
    link: "",
    icon: drIcon
  },
  {
    link: "",
    icon: beIcon
  },
  */
  {
    link: "https://www.linkedin.com/company/uonsolutions/",
    icon: inIcon
  },
];

const BurgerMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #0b0b0b;
  color: white;
  width: 428px;
  z-index: 49;
  position: absolute;
  top: 0;
  right: 0;
  opacity: ${({ burger }) => (burger ? 1 : 0)};
  visibility: ${({ burger }) => burger};
  transform: ${({ burger }) => (burger ? "none" : "translateX(135%)")};
  position: fixed;
  transition: all 0.75s ease;
  user-select: none;
  box-shadow: -9px 0px 62px 0px rgba(0, 0, 0, 0.82);

  @media (max-width: 600px) {
    width: 100vw;
  }
  @media (max-width: 400px) {
    width: inherit;
    height: 100%;
  }
  .links {
    margin-left: 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 2;
    a {
      text-decoration: none;
      color: #fff;
      font-family: "Fira Sans";
      line-height: 96px;
      font-size: 36px;
      @media screen and (max-height: 800px) {
        line-height: 56px;
        font-size: 26px;
      }
    }
  }
  .location {
    margin-left: 90px;
    flex: 1;
    h4 {
    }
    p {
      font-family: "Fira Sans";
      font-size: 12px;
      line-height: 28px;
    }
  }
  .icons {
    border-top: 0.5px solid rgba(255, 255, 255, 0.2);
    padding: 45px;
    display: flex;
    justify-content: center;
    @media screen and (max-height: 600px) {
      padding: 15px;
    }
    @media (max-width: 600px) {
      margin-bottom: 25px;
    }
    svg {
      padding: 20px;
      @media screen and (max-height: 600px) {
        padding: 10px;
      }
    }
  }
`;

const links = [
  { text: "Home", path: "/" },
  { text: "Team", path: "/team" },
  { text: "Contact", path: "/contact" }
];

const BurgerMenu = props => {
  BurgerMenu.handleClickOutside = (e) => props.toggleBurger(false);
  return (
    <BurgerMenuContainer burger={props.burger}>
      <div className="links">
        {links.map((link, key) => {
          return (
            <Link onClick={()=>props.toggleBurger(false)} to={link.path} key={key}>
              {link.text}
            </Link>
          );
        })}
      </div>
      <div className="location">
        <h4>Belgrade</h4>
        <p>Dimitrija Tucovića 89</p>
        <p>office@uon.rs</p>
        <p>+381 60 354 5464</p>
      </div>
      <div className="icons">
        {socialMedia.map((sm, key) => (
          <a href={sm.link} target="_blank" rel="noopener noreferrer" key={key}>
            <InlineSVG src={sm.icon} />
          </a>
        ))}
      </div>
    </BurgerMenuContainer>
  );
};

const clickOutsideConfig = {
  handleClickOutside: () => BurgerMenu.handleClickOutside
};

export default onClickOutside(BurgerMenu, clickOutsideConfig);
